import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader } from '../common/Feedback';

export default function ProtectedRoute({ children, allowRoles }) {
  const { actor, loading } = useAuth();

  if (loading) return <Loader text="Checking your session..." />;
  if (!actor) return <Navigate to="/login" replace />;
  if (allowRoles && !allowRoles.includes(actor.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
